







































import { Component, Vue, Provide } from "vue-property-decorator";
import IdentifyInfo from "./components/IdentifyInfo.vue";
import OtherInfo from "./components/OtherInfo.vue";
import Table from "@/components/table.vue";
import { localGet, setMetaData, timeFormat } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";

@Component({
  name: "orderDeal",
  components: { IdentifyInfo, OtherInfo, Table },
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "idInfo";
  @Provide() private tableData: any = [{ opUid: 123, phoneObject: 22 }];
  @Provide() private changeTableData: any = [{ opUid: 123, phoneObject: 22 }];
  @Provide() private labelData: any = [
    { label: "userInfo.loanHistory", value: "orderid" },
    { label: "userInfo.loanAmount", value: "amount" },
    { label: "userInfo.TheTerm", value: "loanperiod" },
    { label: "userInfo.State", value: "loanstatus" },
    { label: "userInfo.applyTime", value: "applytime" },
    { label: "userInfo.processingTime", value: "checktime" },
    { label: "userInfo.loanTime", value: "loantime" },
    { label: "userInfo.closingTime", value: "finishtime" },
    { label: "userInfo.overdueDays", value: "overduedays" },
  ];
  @Provide() private changeLabelData: any = [
    { label: "id", value: "id" },
    { label: "userInfo.AccountNumber", value: "accountid" },
    { label: "userInfo.UpdateItems", value: "recordtype" },
    { label: "userInfo.OriginalValue", value: "original" },
    { label: "userInfo.TheCurrentValue", value: "edit" },
    { label: "userInfo.TimeChange", value: "ctime" },
    { label: "userInfo.ModifiedBy", value: "opuid" },
  ];
  @Provide() private basicInfo: any = [];
  @Provide() private otherInfo: any = [];
  @Provide() private creditInfo: any = [];
  @Provide() private creditInfoTitle: string = "";
  @Provide() private pageSize: any = 20; //分页页数
  @Provide() private pagerCount: any = 0; //总条数
  @Provide() private changePageCount: any = 0;
  @Provide() private imgsInfo: any = [];
  @Provide() private appname: any = '';

  private created() {
    
    this.getQuestion()
  }

    // 审核问题
  private async getQuestion() {
    const { listVerifyQuestion }: any = await import(
      "@/request/examineDetail"
    );
    let _arg = {
      ticketItemId: this.$route.query.ticketitemid,
      orderId: this.$route.query.orderid,
      customerId: this.$route.query.customerid,
      ticketId: this.$route.query.ticketid,
      appname: this.$route.query.appname,
    };
    let res = await listVerifyQuestion(_arg, this);
    if (res) {
      let data = typeof res == "object" ? res : JSON.parse(res);
      this.appname = data.accountbase.appname
      this.getCustomerDetail(0, this.pageSize);
    }
  }

  private refreshTable(pageIndex: number, pageSize: number) {
    this.getCustomerDetail(pageIndex, pageSize);
  }

  // private getCustomerDetailFuc(data: any) {
  //   if (data.detailtabsList) {
  //     if (
  //       data.detailtabsList.length > 0 &&
  //       data.detailtabsList[0].sectionsList.length > 1
  //     ) {
  //       this.basicInfo = data.detailtabsList[0].sectionsList[0];
  //       this.imgsInfo = data.detailtabsList[0].sectionsList[1];
  //     }
  //     if (data.detailtabsList.length > 1) {
  //       this.otherInfo = data.detailtabsList[1].sectionsList;
  //     }
  //     if (data.detailtabsList.length > 2) {
  //       this.creditInfoTitle = data.detailtabsList[2].tabname;
  //       this.creditInfo = data.detailtabsList[2].sectionsList;
  //     }
  //   }

  //   data.loanhistoryList.forEach((item: any) => {
  //     item.applytime = item.applytime && timeFormat(item.applytime);
  //     item.checktime = item.checktime && timeFormat(item.checktime);
  //     item.loantime = item.loantime && timeFormat(item.loantime);
  //     item.finishtime = item.finishtime && timeFormat(item.finishtime);
  //   });
  //   this.tableData = data.loanhistoryList;
  //   this.pagerCount = data.totalloanhistory;

  //   data.changelogList.forEach((item: any) => {
  //     item.ctime = item.ctime && timeFormat(item.ctime);
  //   });
  //   this.changeTableData = data.changelogList;
  //   this.changePageCount = data.totalchangelog;
  // }
  private async getCustomerDetail(pageIndex: number, pageSize: number) {
    const {
      setGetCustomerDetailReq,
      getCustomerDetailRequest,
    }: any = await import("@/request/getCustomerDetail");
    let data = await getCustomerDetailRequest.handleHttp(
      setGetCustomerDetailReq({
        id: this.$route.query.customerid,
        systemtype: 1,
        pageIndex: pageIndex,
        pageSize: pageSize,
        appname: this.appname
      }),
      this
    );
    if (data.detailtabsList) {
      if (
        data.detailtabsList.length > 0 &&
        data.detailtabsList[0].sectionsList.length > 0
      ) {
        this.basicInfo = data.detailtabsList[0].sectionsList[0];
        this.imgsInfo = data.detailtabsList[0].sectionsList[1];
      }
      if (data.detailtabsList.length > 1) {
        this.otherInfo = data.detailtabsList[1].sectionsList;
      }
      if (data.detailtabsList.length > 2) {
        this.creditInfoTitle = data.detailtabsList[2].tabname;
        this.creditInfo = data.detailtabsList[2].sectionsList;
      }
    }

    data.loanhistoryList.forEach((item: any) => {
      item.applytime = item.applytime && timeFormat(item.applytime);
      item.checktime = item.checktime && timeFormat(item.checktime);
      item.loantime = item.loantime && timeFormat(item.loantime);
      item.finishtime = item.finishtime && timeFormat(item.finishtime);
    });
    this.tableData = data.loanhistoryList;
    this.pagerCount = data.totalloanhistory;

    data.changelogList.forEach((item: any) => {
      item.ctime = item.ctime && timeFormat(item.ctime);
    });
    this.changeTableData = data.changelogList;
    this.changePageCount = data.totalchangelog;
  }
}
